export default {
  tickets: (state) => state.tickets,
  comments:(state) => state.comments,
  currentlyAddedComment:(state) => state.currentlyAddedComment,
  currentTicket:(state)=> state.currentTicket
};
